import {Pagination} from '../../common/commons.types';
import axios, {AxiosRequestConfig} from 'axios';
import {appointmentsApiUri} from '../../common/config/uri-api';
import {Appointment, AppointmentOrder, AppointmentStatus} from "./account.types";
import {formatISO} from "date-fns";

export const getAppointmentList = async (codeBouton: string, limit: number, offset: number, token?: string, status?: AppointmentStatus, order?: AppointmentOrder, from?: Date | number, to?: Date | number): Promise<Pagination<Appointment>> => {
    const config: AxiosRequestConfig = {
        params: {
            customerId: 'me',
            offset,
            limit,
            status,
            order,
            from: from ? formatISO(from) : undefined,
            to: to ? formatISO(to) : undefined
        }
    };
    if (token) {
        config.headers = {Authorization: `Bearer ${token}`};
    }
    const response = await axios.get<Pagination<Appointment>>(`${appointmentsApiUri}/${codeBouton}/appointments?`, config);
    return response.data;
}